<template>
  <Modal
    v-if="showConfirmationModal"
    :config='modalConfig.confirmTaxSavings'
    @btn1Action="routeToAccountDetails(config)"
    @btn2Action="routeToDashboard()">
  </Modal>

</template>

<script>
import Modal from '@/components/common/Modal.vue'

export default {
  name: 'ConfirmTaxSavings',
  components: {
    Modal
  },
  props: {
    config: Object
  },
  data () {
    return {
      showConfirmationModal: this.config.showConfimModal,
      modalConfig: {
        confirmTaxSavings: {
          enabled: true,
          title: this.$t('amendTaxAccount.amendSuccessMessage'),
          body: this.$t('amendTaxAccount.subtitle'),
          persistent: true,
          btn1Label: this.$t('termDepositActions.breakDeposit.viewAccDetailsBtnLabel'),
          btn2Label: this.$t('termDepositActions.breakDeposit.goToDashboardBtnLabel'),
          width: 650
        }
      }
    }
  },
  methods: {
    routeToDashboard () {
      setTimeout(() => {
        this.$router.replace({ path: '/home' })
      }, 600)
    },
    async routeToAccountDetails (props) {
      const item = this.config.accountDetails
      this.$router.replace({
        name: 'AccountDetails',
        params: {
          product: item,
          balance: item.subscriptionAmountUsed,
          accountId: item.accountId,
          accountType: item.accountType,
          currency: item.currency,
          navToTab: 1
        }
      })
    }
  }
}
</script>
